import React from 'react'
import './FAQ.css'
import withLayout from '../../withLayout'

const FAQ = () => (
  <div className='faq'>
    <h2>FAQ</h2>
    <p />
    <h3>¿No me aparece la nueva quiniela?</h3>
    <p>Cierra la página, vuelve a abrirla y vuelve a abrir la pestaña “Partidos”, si no aparece, contáctanos.</p>
    <h3>¿No tienen notificaciones?</h3>
    <p>Por el momento no, estamos trabajando en la aplicación para poder ofrecerles ese servicio. Por lo pronto, activa las notificaciones de nuestra página en Facebook, Twitter o Instagram para recordarles.</p>
    <h3>¿Cuántos grupos puedo hacer?</h3>
    <p>Los que gustes, no tenemos límite para hacer quiniela.</p>
    <h3>¿Tengo que llenar cada una de las quinielas independientemente?</h3>
    <p>Pensamos que dependido del grupo en el que participes, quieras poner resultados diferentes, por eso se llena cada una de las quinielas, pero estaremos trabajando en la opción de llenar automáticamente todos tus grupos con los mismos resultados.</p>
    <h3>¿Qué es la versión Premium?</h3>
    <p>Es una versión para administradores de quinielas, es decir, personas que quieran gestionar el dinero que se están jugando, es decir, les va a dar la opción de activar o desactivar a los participantes que han pagado o no.</p>
  </div>
)

export default withLayout(FAQ, null)
